import axios from 'axios';
import React from 'react'
import { useState } from 'react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import Notify from '../../utils/useNotify';

export default function UpdateStatus({ referenceProp, token, localhost, t, deliveryStatus, setDeliveryStatus, orderStatus, setOrderStatus }) {
  const navigate = useNavigate();
  const [paymentMethod, setPaymentMethod] = useState("");
  const [threeLoading, setThreeLoading] = useState(true);

  const statusOptions = {
    delivery: ['pending', 'out-for-delivery', 'delivered', 'canceled'],
    order: ['in_progress', 'completed', 'canceled']
  };

  const fetchStatus = async () => {
    try {
      const res = await axios.get(`${localhost}admin/get-order-status/${referenceProp}`,
        { headers: { Authorization: `Bearer ${token}` } });
      setDeliveryStatus(res.data.delivery_status);
      setOrderStatus(res.data.collection_status);
      setPaymentMethod(res.data.method);
      setThreeLoading(false);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchStatus();
  }, []);

  const handleSaveChanges = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${localhost}admin/set-order-status/${referenceProp}`,
        { "collection_status": orderStatus, "delivery_status": deliveryStatus },
        { headers: { Authorization: `Bearer ${token}` } });

      Notify("success", t("save-order-details-success"));
      setTimeout(() => navigate("/admin/orders"), 1000);
    } catch (err) {
      Notify("error", t("save-order-details-error"));
      // console.error(err);
    }
  }

  if (threeLoading) {
    return (
      <div className="border border-gray-200 rounded-lg shadow-sm overflow-hidden bg-white min-h-32 flex items-center justify-center">
        <div className="loading-spinner-40" />
      </div>
    )
  };

  return (
    <form onSubmit={handleSaveChanges}>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2.5">{t("payment-method")}</label>
          <p>{t(paymentMethod)}</p>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">{t("order-status")}</label>
          <select value={orderStatus} onChange={(e) => setOrderStatus(e.target.value)}
            className="w-full rounded-md border border-gray-300 py-2 px-3 shadow-sm focus:border-orange-500 focus:outline-none focus:ring-1 focus:ring-orange-500" required>
            <option value="">{t("select-order-status")}</option>
            {statusOptions.order.map((status) => (
              <option key={status} value={status}>
                {t(status)}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">{t("delivery-status")}</label>
          <select value={deliveryStatus} onChange={(e) => setDeliveryStatus(e.target.value)}
            className="w-full rounded-md border border-gray-300 py-2 px-3 shadow-sm focus:border-orange-500 focus:outline-none focus:ring-1 focus:ring-orange-500" required>
            <option value="">{t("select-delivery-status")}</option>
            {statusOptions.delivery.map((status) => (
              <option key={status} value={status}>
                {t(status)}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="mt-6 flex justify-end space-x-3">
        <a href="/admin/orders" className="rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2">
          {t("cancel")}
        </a>
        <button type="submit" className="rounded-md border border-transparent bg-orange-600 px-4 py-2 text-sm font-medium text-white hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2">
          {t("save-changes")}
        </button>
      </div>
    </form>
  )
};